import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const NIN = ensureStatuses({
	TRICK_ATTACK: {
		id: 3254,
		name: 'Trick Attack',
		icon: iconUrl(212918),
		duration: 15000,
	},

	KUNAIS_BANE: {
		id: 3906,
		name: 'Kunai\'s Bane',
		icon: iconUrl(212923),
		duration: 15000,
	},

	MUG: {
		id: 3183,
		name: 'Mug',
		icon: iconUrl(214942),
		duration: 20000,
	},

	DOKUMORI: {
		id: 3849,
		name: 'Dokumori',
		icon: iconUrl(212920),
		duration: 20000,
	},

	HIGI: {
		id: 3850,
		name: 'HIGI',
		icon: iconUrl(212921),
		duration: 30000,
	},

	KASSATSU: {
		id: 497,
		name: 'Kassatsu',
		icon: iconUrl(212902),
		duration: 15000,
	},

	DOTON: {
		id: 501,
		name: 'Doton',
		icon: iconUrl(212904),
		duration: 24000,
	},

	SHADOW_WALKER: {
		id: 3848,
		name: 'Shadow Walker',
		icon: iconUrl(212919),
		duration: 20000,
	},

	TEN_CHI_JIN: {
		id: 1186,
		name: 'Ten Chi Jin',
		icon: iconUrl(212911),
		duration: 6000,
	},

	TENRI_JINDO_READY: {
		id: 3851,
		name: 'Tenri Jindo Ready',
		icon: iconUrl(212922),
		duration: 30000,
	},

	BUNSHIN: {
		id: 1954,
		name: 'Bunshin',
		icon: iconUrl(212912),
		duration: 30000,
	},

	SHADE_SHIFT: {
		id: 488,
		name: 'Shade Shift',
		icon: iconUrl(210605),
		duration: 20000,
	},

	MEISUI: {
		id: 2689,
		name: 'Meisui',
		icon: iconUrl(212914),
		duration: 30000,
	},

	RAIJU_READY: {
		id: 2690,
		name: 'Raiju Ready',
		icon: iconUrl(217597),
		duration: 30000,
	},

	PHANTOM_KAMAITACHI_READY: {
		id: 2723,
		name: 'Phantom Kamaitachi Ready',
		icon: iconUrl(212917),
		duration: 45000,
	},
})
